<template>
  <div class="admin-layout d-flex">
    <AdminSidebar class="sidebar" />

    <div class="main-content flex-fill">
      <AdminNavbar />
      <div class="p-4">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import AdminNavbar from "./AdminNavbar.vue";
import AdminSidebar from "./AdminSidebar.vue";

export default {
  components: { AdminNavbar, AdminSidebar },
};
</script>

<style scoped>
.admin-layout {
  min-height: 100vh;
  display: flex;
}
.main-content {
  flex: 1;
  background-color: #f5f5f5;
  height: 100vh;
  overflow-y: auto;
}
.sidebar {
  width: 220px;
  background-color: #1e1e2f;
}
</style>
